import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a restaurant icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <RestaurantIcon width={24} />
 */
const RestaurantIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M13 3V9C13 11.2 11.2 13 9 13V21C9 21.55 8.55 22 8 22C7.45 22 7 21.55 7 21V13C4.8 13 3 11.2 3
            9V3C3 2.45 3.45 2 4 2C4.55 2 5 2.45 5 3V9H7V3C7 2.45 7.45 2 8 2C8.55 2 9 2.45 9 3V9H11V3C11 2.45
            11.45 2 12 2C12.55 2 13 2.45 13 3ZM20 2.12C19.85 2.12 19.53 2.21 19.5 2.22C18.62 2.46 17.55 3.1
            17 3.77C16.7 4.14 16.43 4.61 16.25 5.05C16.09 5.34 16 5.66 16 6V12C16 13.1 16.9 14 18 14H19V21C19
            21.55 19.45 22 20 22C20.55 22 21 21.55 21 21C21 21 21 3.16 21 3.12C21 2.57 20.55 2.12 20 2.12Z`}
        />
    </SvgIcon>
)

RestaurantIcon.defaultProps = defaultProps

export { RestaurantIcon }
